// @flow
import React from 'react'
import classnames from 'classnames'
import styles from './radio-button.module.scss'

interface Props {
  className?: string
  children: React.ReactNode
  id: string
  value: string
  name: string
  checked: boolean
  bordered?: boolean
  onChange: () => void
}

const RadioButton = ({
  className = '',
  id,
  name,
  value,
  checked,
  bordered = false,
  onChange,
  children,
}: Props) => (
  <label
    htmlFor={id}
    className={classnames(styles.container, className, {
      [styles.checked]: checked,
      [styles.bordered]: bordered,
    })}
  >
    <input
      id={id}
      type="radio"
      name={name}
      value={value}
      checked={checked}
      onChange={onChange}
      className={styles.input}
    />
    <span className={styles.check} />
    {children}
  </label>
)

export default RadioButton
